import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { NoContactsFound } from 'components/templates/NoSearchResult'
import { CONSTS } from 'config/objectConst'
import { importsHooks } from 'features/imports'
import { useParams } from 'react-router-dom'
import { useSwitcher } from 'shared/hooks'
import { hooks as ODataHooks } from 'shared/odata'
import { ContactsTable } from 'shared/ui'

import { ExportContacts } from '../../../../components/organisms/ExportContacts'
import { api } from '../../api'
import { ColumnSettingsGeneral } from '../ColumnSettings/ColumnSettings'
import { FilterHeader } from '../FilterHeader/FilterHeader'
import { Modal } from '../Filters/Modal'
import { GeneralTable } from '../GeneralTable/GeneralTable'
import { NotExistYet } from './NotExistYet'
import css from './Page.module.css'
import { Title } from './Title'

export function ContactsPage() {
	const exportModal = useSwitcher(false)
	const { id } = useParams()

	const { isApplied, params } = ODataHooks.useParseUrl('Import')
	const listQuery = api.useContactPageQuery(params, {
		refetchOnMountOrArgChange: true
	})

	ODataHooks.useCheckPagination({
		data: listQuery.data,
		isApplied,
		isReady: listQuery.isSuccess && !listQuery.isFetching
	})

	importsHooks.useInit()

	const total = listQuery.data?.total ?? 0
	const isHaveContact = Boolean(total)

	const isNotExist =
		!id &&
		listQuery.isSuccess &&
		!isHaveContact &&
		!isApplied &&
		!listQuery.isFetching
	const isVideoEnabled = CONSTS.ON_BOARDING.INTRODUCTION_VIDEO.ENABLED
	const shouldShowOnboarding = isNotExist && isVideoEnabled
	const isMainFlow = listQuery.isSuccess && !shouldShowOnboarding

	const isFilterEmpty = isMainFlow && isApplied && !isHaveContact
	const shouldShowTable = isMainFlow && !isFilterEmpty
	const hideFilterHeaderControls = !isVideoEnabled && !isHaveContact && !isApplied

	if (listQuery.isLoading) {
		return <FullLoader />
	}

	return (
		<main
			className={clsx(css.root, 'main app-scroll', {
				[css.centered]: !isMainFlow,
				[css.content]: isMainFlow
			})}
		>
			{shouldShowOnboarding && <NotExistYet onOpen={exportModal.on} />}
			{listQuery.isFetching && ContactsTable.Spinner}
			{isMainFlow && (
				<>
					<Title />
					<FilterHeader hideSearchAndFilters={hideFilterHeaderControls}>
						<div className={css.actions}>
							<ExportContacts />

							{CONSTS.IS_RESIZABLE_TABLE && <ColumnSettingsGeneral />}
						</div>
					</FilterHeader>

					{isFilterEmpty && <NoContactsFound />}
					{shouldShowTable && (
						<GeneralTable
							contacts={listQuery.data?.documents ?? []}
							filter={params}
							total={total}
						/>
					)}
					<Modal />
				</>
			)}
		</main>
	)
}
